module.exports = __webpack_public_path__ + "static/media/98c04bdc-d5af-48da-8678-2179dc363257.a5f56d52.mp4";